import { render } from "./VitrineSectionBlock.vue?vue&type=template&id=0f21dc1a"
import script from "./VitrineSectionBlock.vue?vue&type=script&lang=js"
export * from "./VitrineSectionBlock.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__